import {
  Box,
  FieldText,
  ModalBody,
  ModalFoot,
  Text,
} from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { ChangeEvent, useCallback } from 'react';


import { useMigrateSchedule } from '../../hooks/useMigrateSchedule';
import { useMigrateOpeningHoursContext } from '../../migrateOpeningHours.context';
import type { BaseProps } from '../../types/props';

export function NameSchedule(props: BaseProps): JSX.Element {
  const {
    name,
    setters: { setName },
    step,
    onCancel,
  } = useMigrateOpeningHoursContext();

  const [handleCreateSchedule, isScheduleCreationLoading] =
    useMigrateSchedule(props);

  const handleSubmit = useCallback(() => {
    ampli.businessHoursMigrationWizardFormSubmitted({ step: step + 1 });
    handleCreateSchedule();
  }, [step, handleCreateSchedule]);

  const handleNameChange = useCallback(
    (event?: ChangeEvent<HTMLInputElement>) =>
      setName(event?.target?.value || ''),
    [setName],
  );

  return (
    <>
      <ModalBody>
        <Text.Paragraph subdued variant="2">
          Last but not least, give the schedule a name you’ll easily recognize.
        </Text.Paragraph>
        <Box margin="400 0 0">
          <FieldText
            label="Name"
            placeholder="e.g Italy or HR Department"
            input={{
              name: 'schedule name',
              value: name,
              onChange: handleNameChange,
            }}
          />
        </Box>
      </ModalBody>
      <ModalFoot
        cancelOnClick={onCancel}
        confirmProps={{ disabled: !name, isLoading: isScheduleCreationLoading }}
        confirmName="Create a schedule"
        confirmOnClick={handleSubmit}
      />
    </>
  );
}
